import styles from "./VesselList.module.scss";

type VesselRowProps = {
  title: string;
  value: string | null;
};

export const VesselRow: RFC<VesselRowProps> = ({ title, value }) => {
  return (
    <div className={styles.row}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};
